import React from "react";
import ExploreMarketplaceBanner from "./ExploreMarketplaceBanner";


// Main component for Marketplace 

export default function ExploreMarketplace() {
  return (
    <>
        {/* Banner */}
      <ExploreMarketplaceBanner />
    </>
  );
}
